import angular from 'angular';
import { MensagemErroInputController } from './mensagem-erro-input.controller';

export class MensagemErroInputComponent implements angular.IComponentOptions {
    static selector = 'mensagemErroInput';
    static controller = MensagemErroInputController;
    static template = require('!!html-loader!./mensagem-erro-input.html');
    static transclude = true;
}
